import React, {useEffect, useRef, useState} from 'react';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import api from "../../services/api";
import Box from "@mui/material/Box";
import {Button, Dialog, DialogTitle, Typography} from '@mui/material';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";


export const DailyTransferSchedule = ({date}: { date: any }) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [currentDate, setCurrentDate] = useState(date);
  const [events, setEvents] = useState([]);
  const searchParams = new URLSearchParams({
    date: currentDate,
  });
  const [selectedEvent, setSelectedEvent] = useState<any | null>(null);
  const calendarRef = useRef<FullCalendar | null>(null); // 📌 ref a calendarhoz

  useEffect(() => {
    setLoading(true);
    api.get(`/service-reservations/daily-transfers`, searchParams).then((result: any) => {
      setEvents(result);
    }).finally(() => {
      setLoading(false);
    });
  }, [currentDate]);

  // 📌 figyeljük a külső prop `date` változást, és léptetjük a naptárt
  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(date);
      setCurrentDate(date);
    }
  }, [date]);

  return <Box
    sx={{
      '& .fc-toolbar-title':{
        fontSize: '18px'
      },
      '& .fc-button.fc-today-button, .fc-button.fc-prev-button, .fc-button.fc-next-button':{
        backgroundColor: '#2c65de',
        border: 'none',
        textTransform: 'uppercase'
      },
      '& .fc-toolbar.fc-header-toolbar':{
        p: '2px',
        m: 0,
        background: '#f1f1f1'
      },
      opacity: loading ? 0.5 : 1,
      pointerEvents: loading ? 'none': 'all',
      maxHeight: 'calc(100vh - 200px)',
      height: '100%',
      overflow: 'auto'
    }}
  >
    <FullCalendar
      ref={calendarRef} // 🔗 ref hozzárendelés
      initialDate={currentDate}
      plugins={[timeGridPlugin]}
      initialView="timeGridDay"
      allDaySlot={false}
      slotMinTime="00:00:00"
      slotMaxTime="24:00:00"
      events={events}
      height="auto"
      slotLabelFormat={{
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }}
      eventTimeFormat={{
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }}
      datesSet={(arg) => {
        const full = arg.startStr;
        const dateOnly = full.split('T')[0];
        setCurrentDate(dateOnly);
      }}
      eventClick={(info) => {
        setSelectedEvent(info.event); // 📌 event objektum eltárolása
      }}
    />

    {selectedEvent && (
      <Dialog
        open={!!selectedEvent}
        onClose={() => setSelectedEvent(null)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Event data</DialogTitle>
        <DialogContent dividers>
          {selectedEvent && (
            <>
              <Typography>
                <strong>Service Provider:</strong>{" "}
                {selectedEvent.extendedProps?.service_provider}
              </Typography>
              <Typography>
                <strong>Start:</strong>{" "}
                {selectedEvent.start?.toLocaleString()}
              </Typography>
              <Typography>
                <strong>End:</strong>{" "}
                {selectedEvent.end?.toLocaleString()}
              </Typography>
              <Typography>
                <strong>Group:</strong>{" "}
                {selectedEvent.extendedProps?.group}
              </Typography>

              <Typography>
                <strong>Activity:</strong>{" "}
                {selectedEvent.extendedProps?.activity}
              </Typography>

              <Typography>
                <strong>Service:</strong>{" "}
                {selectedEvent.extendedProps?.service}
              </Typography>

            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedEvent(null)}>Bezár</Button>
        </DialogActions>
      </Dialog>
    )}
    {/* 📌 Részletek popup */}


  </Box>;


};
